import { Component, Input, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-pos-elapsed-time',
  templateUrl: './pos-elapsed-time.component.html',
  styleUrls: ['./pos-elapsed-time.component.sass'],
})
export class PosElapsedTimeComponent implements OnInit {
  @Input() running: boolean = false;
  @Input() startTime: Date = new Date();
  @Input() endTime: Date | undefined;

  days: number = 0;
  hours: number = 0;
  minutes: number = 0;
  seconds: number = 0;

  timerSubscription: Subscription = new Subscription();

  constructor() {}

  ngOnInit() {
    this.startTime = new Date(this.startTime);
    this.endTime = new Date(this.endTime || new Date());

    if (this.running) {
      this.startTimer();
    } else {
      this.calculateTimeDifference();
    }
  }

  startTimer() {
    this.timerSubscription = timer(0, 1000).subscribe(() => {
      this.calculateTimeDifference();
    });
  }

  calculateTimeDifference() {
    const differenceInMilliseconds =
      (this.endTime || new Date()).getTime() - this.startTime.getTime();

    this.days = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    this.hours = Math.floor(
      (differenceInMilliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    this.minutes = Math.floor(
      (differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    this.seconds = Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000);
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
